import {Component, ViewChild} from '@angular/core';
import {Keyboard, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, Util} from '../../../app/util';
import {ENUM, TAction, TGeradorFlag, TGeradorLine, TFinanceSide, TFolloweLock, TPaybookFato} from "../../../app/enum";
import {Searched} from "../../../components/searched/searched";
import {MessageService} from "../../../providers/message-service";
import {FormControl} from "@angular/forms";
import {LogadoService} from "../../../providers/logado-service";
import {WebstorService} from "../../../providers/webstor-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {ProfilePagePage} from "../profile-page/profile-page";
import {PaybookMenuPage} from "../paybook-menu/paybook-menu";
import {ProfileService} from "../../../providers/profile-service";
import {GeradorMenuPage} from "../gerador-menu/gerador-menu";


@Component({
    selector: 'page-paybook-find',
    templateUrl: 'paybook-find.html',
    providers: [WebstorService, HotspotService, ProfileService]
})
export class PaybookFindPage {

    TFinanceSide: any = TFinanceSide;

    enum: any;
    config: any;

    etapa: number;
    _count: number = 5;

    userset: any;
    profile: any;

    hotspotID: number;
    geradorID: number;
    profileID: number;

    rootspot: any;
    copyspot: any;

    rootbok: any;
    rootile: any;
    payyears: any;

    searchQtde: number = 0;
    searchFind: boolean;
    searchWork: boolean;
    searchTerm: string = '';
    searchControl: FormControl = new FormControl();
    searching: boolean = false;

    limitQtde: number = 0;
    limitCount: number = 0;
    limitPage: number = 0;



    @ViewChild(Searched) searched: Searched;

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public util: Util,
                public messageService: MessageService, private keyboard: Keyboard,
                public webstorService: WebstorService, public profileService: ProfileService, public logadoService: LogadoService,
                public hotspotService: HotspotService) {


        this.enum = ENUM;
        this.config = CONFIG;

        this.etapa = this.navParams.get('etapa');
        this.userset = this.navParams.get('userset');
        this.searchTerm = this.navParams.get('searchTerm');

        this.hotspotID = this.navParams.get('hotspotID');
        this.geradorID = this.navParams.get('geradorID');
        this.profileID = this.navParams.get('profileID');
        this.profile = this.navParams.get('profile');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Book', '/profile-book');

        if (this.etapa == 0) this.searchChange();
        if (this.etapa == 1) this.paybookFind(this.profile);

    }

    getTitle() {

        if (this.etapa == 0) return 'Paybook';
        if (this.etapa == 1) return this.profile.ProfileShow;

    }

    searchChange() {

        if (this.searchTerm.length == 0) this.payfindInit();
        if (this.searchTerm.length < 4) return;

        //Database Field na Bridge tem tamanho de 45 para gravar a pesquisa.
        if (this.searchTerm.length > 45) this.searchTerm = this.searchTerm.slice(0, 45);

        this.searchQtde++;


        //#GAMBI - Qdo clica no botaozinho de X para limpar o texto ele nao fecha o teclado
        this.keyboard.close();
        this.keyboard.close();
        //Por isso esta com duas vezes ele


        //Timeout so para dar tempo de fechar o teclado e comecar a busca, fica mais bonito
        setTimeout(() => this.profileBook(), 300);

    }

    searchStart(isEnter) {

        if (!isEnter) return;

        this.limitPage = 0;
        this.paybookFind(null);

    }

    searchClose() {

        this.keyboard.close();

    }

    payfindInit() {

        //this.rootile = null;
        this.profile = null;
        this.payyears = null;
        this.searchTerm = '';
        this.keyboard.close();

    }

    profilePage() {

        let object = {profileID: this.profile.ProfileID};
        this.navCtrl.push(ProfilePagePage, object);

    }

    profileCnpj() {

        this.util.toastSimply('CNPJ não possui perfil');

    }

    profileBook() {

        this.searching = true;
        this.payyears = null;
        this.rootbok = null;
        this.rootile = null;

        let params = '&ProfileText=' + this.searchTerm + '&HotspotID=' + this.hotspotID;

        this.profileService.profile(TAction.acBook, 0, null, params)
            .finally(() => {
                if (this.rootile && this.rootile.Profiles.length != 1) this.searching = false;
            })
            .subscribe(
                data => {
                    this.rootile = data;
                    if (data.Profiles.length == 1) this.paybookFind(data.Profiles[0]);
                },
                erro => this.util.alertResult(erro)
            );

    }

    followeLock(event) {

        let followe = this.util.deepCopy(this.profile.Followe);

        let onLock = (followeLock) => {

            event.starteLoader(false);
            followe.FolloweLock = followeLock;
            this.hotspotService.followe(TAction.acLock, this.hotspotID, this.profile.ProfileID, followe)
                .finally(() => event.cancelLoader())
                .subscribe(
                    data => this.util.populateObj(this.profile.Followe, followe),
                    erro => this.util.alertResult(erro)
                );

        };

        if (followe.FolloweLock) {
            onLock(TFolloweLock.fwLiberado);
            return;
        }

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TFolloweLock);
        let buttons: Array<any> = [];
        arrayEnum.forEach(lock => buttons.push({text: lock.slice(2, 99), value: TFolloweLock[lock]}));

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = 0;
        this.util.pickerOpen(columns, onLock);

    }

    paybookFind(profile) {

        this.searching = true;
        //this.rootile = null;
        this.profile = profile;

        let profileID = (this.profile ? this.profile.ProfileID : this.profileID);
        let action = (this.geradorID ? TAction.acGera : (this.profileID ? TAction.acUser : TAction.acSpot));

        this.hotspotService.paybook(action, 0, this.hotspotID, this.geradorID, profileID)
            .finally(() => this.searching = false)
            .subscribe(
                data => this.paybookGoin(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    paybookHide(paybook, event) {

        if (event && typeof event.stopPropagation !== 'undefined') event.stopPropagation();

        let onHide = () => {

            let loading = this.util.loadingDots();
            loading.present();

            this.hotspotService.paybook(TAction.acHide, paybook.PaybookID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {
                        this.util.toastSimply('Checkin excluído com sucesso.');
                        this.logadoService.paybookHide(paybook.PaybookID, this.rootbok.Paybooks);
                        this.dismiss();
                    },
                    erro => {
                        if (event && typeof event.cancelOverslide != 'undefined') event.cancelOverslide();
                        this.util.alertResult(erro);
                    });

        };


        let alerta = '<b>Seu checkin será excluido definitivamente.</b><br/>Este processo não tem volta.<br/><br/>';
        if (!event) this.util.alertQuestion('ATENÇÃO', alerta, 'Eu CONFIRMO', () => onHide, false, true);
        if ( event) onHide();

    }

    paybookMenu(paybook) {

        let object = {etapa: 0, olhaapp: true, fronter: true, profile: paybook.Profile, branded: paybook.Branded, userset: this.userset, paybookID: paybook.PaybookID, paybook: null};
        this.util.modalopen(PaybookMenuPage, 'alto', false, object).subscribe();

    }

    paybookGoin(data) {

        this.etapa = 1;
        this.rootbok = data;
        this.payyears = [];
        this.rootbok.Paybooks.forEach(PB => {

            let year = this.util.strToDate(PB.PaybookCria).getFullYear();
            if (this.payyears.length == 0 || this.payyears[this.payyears.length-1].PaybookYear != year) this.payyears.push({PaybookYear: year, Paybooks: []});
            this.payyears[this.payyears.length-1].Paybooks.push(PB);

        });

    }

    payyearMore(payyear: any, press: boolean) {

        payyear._count = payyear.Paybooks.length;
        this.util.impact();

    }

    contratoMenu() {

        let onOpen = (contrato, contratoSide: TFinanceSide = TFinanceSide.cdTodos) => {

            if (contrato == null) contrato = {
                        HotspotID: this.config.kairos.HotspotID,
                        HotspotIX: 0,
                        ContratoID: 0,
                        ContratoSide: contratoSide,
                        ContratoFato: TPaybookFato.ctVencer,
                        ContratoFlag: TGeradorFlag.ctAberto,
                        ContratoNota: false,
                        ContratoGera: TGeradorLine.glMensal,
                        ContratoMoon: 0,
                        ContratoDayz: 0,
                        ContratoQtde: 0,
                        ContratoLink: '',
                        ContratoUser: '',
                        ContratoPswd: '',
                        ContratoCria: '',
                        ContratoStop: '',
                        Servicos: [],
                        Projeto: this.util.deepCopy(this.copyspot.Hotspots[0].Project),
                        Negocio: this.util.deepCopy(this.copyspot.Hotspots[0].Branded.Negocio),
                        Profile: this.util.deepCopy(this.profile),            
            };

            let copyrat = this.util.deepCopy(contrato);

            let object = {etapa: 0, contratoID: 0, rootrat: contrato, copyrat: copyrat, rootspot: this.rootspot, copyspot: this.copyspot};
            this.util.modalopen(GeradorMenuPage, 'alto', false, object).subscribe();
    
        };

        let onNovo = () => {
            let buttons: Array<any> = [];
            buttons.push({text: 'Crédito',     handler: () => onOpen(null, TFinanceSide.cdCredito)});
            buttons.push({text: 'Débito',      handler: () => onOpen(null, TFinanceSide.cdDebito), role: 'destructive'});
            this.util.sheetOpen(buttons, 'CONTRATO');
        }

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Novo Contrato', handler: () => onNovo()});
        this.rootbok.Contratos.forEach(CT => buttons.push({text: this.util.numerico(CT.ContratoID), handler: () => onOpen(CT)}));
        this.util.sheetOpen(buttons, 'CONTRATO');

    }

    contratFlug(contrato, flug: 'tint' | 'text') {

        if (flug == 'tint') {
            if (contrato.ContratoFlag == TGeradorFlag.ctAberto) return 'CorMato';
            if (contrato.ContratoFlag == TGeradorFlag.ctParado) return 'CorWeek';
            if (contrato.ContratoFlag >= TGeradorFlag.ctFechou) return 'CorFood';
        }

        if (flug == 'text') {
            return TGeradorFlag[contrato.ContratoFlag].slice(2, 99);
        }

    }

    dismiss() {

        if (this.etapa == 1 && this.rootile && this.rootile.Profiles.length > 1) {
            this.etapa = 0;
            return;
        }

        if (this.viewCtrl.isOverlay) this.viewCtrl.dismiss();
        if (!this.viewCtrl.isOverlay) this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/paybook-find/paybook-find.ts